<template>
  <div class="home-page">
    <div class="data-area">

      <StatisticsData
        title="注册用户数"
        :value="statistics.totalUserNum"
        bgColor="#F6F9FC"
        color="#0084ff" 
        :icon="require('@/assets/img/ic_user_quantity@2x.png')" />

      <StatisticsData
        title="设备总数"
        :value="statistics.totalDeviceNum"
        bgColor="#FFFAF5"
        color="#FFB764"
        :icon="require('@/assets/img/ic_device_quantity@2x.png')" />

      <StatisticsData
        title="在线设备"
        :value="statistics.deviceOnline"
        bgColor="#F3FFF8"
        color="#0BD169"
        :icon="require('@/assets/img/ic_online_device@2x.png')" />

      <StatisticsData
        title="激活数"
        :value="statistics.deviceActive"
        bgColor="#FFFAF5"
        color="#FFB764"
        :icon="require('@/assets/img/ic_device_activate_quantity@2x.png')" />

      <StatisticsData
        title="故障数"
        :value="statistics.alarmCount"
        bgColor="#FFF3F3"
        color="#FF7B7B"
        :icon="require('@/assets/img/ic_user_quantity@2x.png')" />

      <StatisticsData
        title="反馈数"
        :value="statistics.feedbackCount"
        bgColor="#F9F8FF"
        color="#4625E8"
        :icon="require('@/assets/img/ic_feedback_quantity@2x.png')" />

      </div>

    <div class="bottom-area" >
      <div class="chart-area" hidden>
        <line-chart ref="userChart"/>
        <line-chart ref="deviceChart"/>
      </div>

      <div class="map-area">
        <MapCharts  title="" mapType="china" :needScale="true" @clickFn="clickMap"></MapCharts>
      </div>

      <div class="table-area">
        <a-table :columns="columns" :data-source="distributionData" :pagination="false" size="middle" :scroll="{ y: 500 }"></a-table>
      </div>

    </div>




  </div>
</template>
<script>

  import StatisticsData from "./_components/StatisticsData";

  import LineChart from "@/components/common/LineChart";
  import HeadInfo from "@/views/common/HeadInfo";
  import MapCharts from "@/components/common/MapCharts";
  import StatisticsDataItem from '../../components/common/StatisticsDataItem'
  import { mapState } from "vuex";
  import moment from "moment";
  moment.locale("zh-cn");

  export default {
    name: "HomePage",
    components: {
      StatisticsData,
      HeadInfo,
      MapCharts,
      StatisticsDataItem,
      LineChart
    },
    data() {
      return {
        statistics: {
          totalDeviceNum: "--",
          activeDeviceRate: "--",
          totalUserNum: "--",
          activeUserRate: "--",
        },
        location: '',
        distributionData:[]
      };
    },
    computed: {
      ...mapState({
        multipage: (state) => state.setting.multipage,
        user: (state) => state.account.user,
        vendor: (state) => state.account.vendor,
      }),
      avatar() {
        return `static/avatar/${this.user.avatar}`;
      },
      columns(){
        return [
          {
            title: "地域",
            dataIndex: "location",
            key: "location",
            customRender(text){
              return text==0 ? "其他": text
            }
          },
          {
            title: "设备数量",
            dataIndex: "deviceCount",
            key: "deviceCount",
            width: 80
          },
          {
            title: "占比",
            dataIndex: "proportion",
            key: "proportion",
            customRender(text){
              if(text==0){
                return "<1%"
              }else{
                return text+"%"
              }
            }
          }
        ]
      }
    },
    methods: {
      //获取设备地域分布
      getDeviceDistribution(level,location){
        this.$get(`admin/home/deviceDistribution?level=${level}&location=${location}`).then(res=>{
          this.distributionData = res.data.sort((a,b)=>{
            return b.deviceCount - a.deviceCount
          })
        })
      },
      clickMap(e) {
        if(e.name == this.location) {
          this.getDeviceDistribution(1,'中国')
        }else{
          this.location = e.name
          this.getDeviceDistribution(2,e.name)
        }
      }

    },
    mounted() {
      this.getDeviceDistribution(1,'中国')

      this.$get("admin/home/statistics").then((r) => {
        let data = r.data;
        this.statistics = data;

        let dateArr = [];
        for (let i = 6; i >= 0; i--) {
          let time = moment().subtract(i, "days").format("MM-DD");
          dateArr.push(time);
        }

        this.$refs.userChart.update({
          chartTitle:"近七日新增用户数",
          pointTitle:"新增用户数",
          xaxis:dateArr,
          values:data.userTrend
        })

        this.$refs.deviceChart.update({
          chartTitle:"近七日新增设备数",
          pointTitle:"新增设备数",
          xaxis:dateArr,
          values:data.deviceTrend
        })

      })

    },
  };
</script>
<style lang="less" scoped>

  .home-page{
    width: 100%;
  }

  .data-area {
    padding: 5px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border: 1px solid #eee;
  }

  .data-item {
    display: flex;
    align-items: center;
    margin-right: 30px;
    border-radius: 3px;
    padding: 8px 20px;
    background: #f5f9fa;
  }

  .data-icon {
  }

  .data-title {
    margin-right: 20px;
    font-size: 16px;
    color: #888888;
  }

  .bottom-area{
    display: flex;
    width: 100%;
  }

  .data-value {
    font-size: 22px;
    color: #0084ff;
  }

  .chart-area {
    width: 320px;
    height: 600px;
  }

  .map-area {
    border: 1px solid #eee;
    height: 600px;
    flex: 1;
  }

  .table-area{
    border: 1px solid #eee;
    width: 220px
  }

</style>



// WEBPACK FOOTER //
// src/views/home/HomePageNursingRobot.vue